export const SET_SCHEDULE_DATE = "SET_SCHEDULE_DATE";
export const CONFIRM_SCHEDULE_DATE = "CONFIRM_SCHEDULE_DATE";
export const CONFIRM_REPEAT_SETTINGS = "CONFIRM_REPEAT_SETTINGS";
export const RESET_SCHEDULE_DATE = "RESET_SCHEDULE_DATE";
export const INIT_CONTENT_PAYLOAD = "INIT_CONTENT_PAYLOAD";
export const RESET_CONTENT_PAYLOAD = "RESET_CONTENT_PAYLOAD";
export const ALTER_CONTENT_PAYLOAD = "ALTER_CONTENT_PAYLOAD";
